import o from"../Chips/Chips.js";var I={PRIMARY:o.colors.PRIMARY,NEGATIVE:o.colors.NEGATIVE,POSITIVE:o.colors.POSITIVE};export{I as DROPDOWN_CHIP_COLORS};
